import React, { createContext, useState } from "react";

import { useShiftInfo } from "./graphql/use-shift-info";

export const FocusShiftContext = createContext();

export const FocusShiftContextProvider = ({ children }) => {
  const [focusShift, setFocusShift] = useState(null);

  const [isVenueFilter, setIsVenueFilter] = useState(true);
  const [isRoleFilter, setIsRoleFilter] = useState(true);

  const [isAvailabilityFilter, setIsAvailabilityFilter] = useState(false);
  const [isTagsFilter, setIsTagsFilter] = useState(false);

  const [isNotExcludedFilter, setIsNotExcludedFilter] = useState(true);
  const [isNotUnsuitableFilter, setIsNotUnsuitableFilter] = useState(true);

  const { tags } = useShiftInfo(focusShift);
  const tagIds = tags?.map(({ id }) => id) || [];

  const ctx = {
    focusShift,
    focusShiftTags: tags,
    focusShiftId: focusShift?.id,

    setFocusShift: (newShift, forceUpdate = false) => {
      if (forceUpdate || newShift?.id !== focusShift?.id) {
        setFocusShift(newShift);

        setIsVenueFilter(true);
        setIsRoleFilter(true);
        setIsAvailabilityFilter(true);
        setIsNotUnsuitableFilter(true);
        setIsNotExcludedFilter(true);
        setIsTagsFilter(true);
      }
    },

    focusFilters:
      focusShift != null
        ? {
            partnerIds: [focusShift.sourceAccountId],
            // shiftTypes: [focusShift.type],
            roleIds: isRoleFilter ? [focusShift.roleRate.roleId] : [],
            availableForShift: isAvailabilityFilter ? focusShift.id : null,
            venueIds: [],
            homeVenueIds: null,
            userIds: null,
            memberTagIds: isTagsFilter && tags?.length > 0 ? tagIds : null,
            forVenueId: isVenueFilter ? focusShift.venue.id : null,
            notExcludedFromVenueId: isNotExcludedFilter
              ? focusShift.venue.id
              : null,
            excludeUnsuitable: isNotUnsuitableFilter
          }
        : null,

    isVenueFilter,
    setIsVenueFilter,
    isRoleFilter,
    setIsRoleFilter,
    isAvailabilityFilter,
    setIsAvailabilityFilter,
    isTagsFilter,
    setIsTagsFilter,
    isNotUnsuitableFilter,
    setIsNotUnsuitableFilter,
    isNotExcludedFilter,
    setIsNotExcludedFilter,

    clearFocusShift: () => {
      setFocusShift(null);

      setIsVenueFilter(true);
      setIsRoleFilter(true);
      setIsNotUnsuitableFilter(true);
      setIsNotExcludedFilter(true);

      setIsAvailabilityFilter(true);
      setIsTagsFilter(true);
    }
  };

  return (
    <FocusShiftContext.Provider value={ctx}>
      {children}
    </FocusShiftContext.Provider>
  );
};

/**
 * Options and filters for the single shift view, to avoid overloading the main component
 */
export const provideFocusShiftContext = Component => props =>
  FocusShiftContextProvider({ children: <Component {...props} /> });
